import React from "react";
import { Toggle } from "../../../../../../components";
import { FORM_KEYS } from "../../../../constants";

/**
 * @desc Toggle public mode for loungefly conventions.
 */
export const TogglePublicLoungefly = (props) => {
  // CONSTANTS ----------------------------------------------------------------

  const errorProps = {
    id: "form-public-loungefly-error",
  };

  const inputProps = {
    id: "toggle-public-loungefly",
    className: "form-control",
    "aria-describedby": errorProps.id,
    ...props,
  };

  const labelProps = {
    className: "switch form-control-label",
    htmlFor: inputProps.id,
    children: "SET TO PUBLIC - LOUNGEFLY",
  };

  // COMPONENT ----------------------------------------------------------------

  const parentProps = {
    inputProps,
    labelProps,
    errorProps,
    fieldName: FORM_KEYS.IS_PUBLIC_LOUNGEFLY,
  };

  return <Toggle {...parentProps} />;
};
